export default __webpack_public_path__ + "static/media/Landing_Page.efa0bf86.PNG";